(() => {
  const initialize = () => {
    const overlay = document.querySelector('[data-dt-halloween-spider]');
    if (!overlay || window.Shopify?.designMode || overlay.dataset.dtHalloweenSpiderInitialized) return;
    overlay.dataset.dtHalloweenSpiderInitialized = 'true';

    const rig = overlay.querySelector('.dt-halloween-spider__rig');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const forcedColors = window.matchMedia('(forced-colors: active)');
    const cycleDelay = 2 * 60 * 1000;
    const cycleDuration = 4400;
    let nextTimer = null;
    let cleanupTimer = null;
    let paused = false;
    let running = false;
    let nextSide = 'left';

    const permitted = () => !paused && !document.hidden && document.hasFocus() && !reducedMotion.matches && !forcedColors.matches;

    const finish = () => {
      if (cleanupTimer !== null) window.clearTimeout(cleanupTimer);
      cleanupTimer = null;
      running = false;
      overlay.hidden = true;
      overlay.classList.remove('is-active');
    };

    const cancel = () => {
      if (nextTimer !== null) window.clearTimeout(nextTimer);
      nextTimer = null;
      finish();
    };

    const schedule = () => {
      if (nextTimer !== null) window.clearTimeout(nextTimer);
      nextTimer = null;
      if (!permitted()) return;
      nextTimer = window.setTimeout(() => {
        nextTimer = null;
        if (!permitted()) {
          finish();
          return;
        }
        if (!running) {
          running = true;
          overlay.dataset.dtSpiderSide = nextSide;
          nextSide = nextSide === 'left' ? 'right' : 'left';
          overlay.hidden = false;
          overlay.classList.add('is-active');
          cleanupTimer = window.setTimeout(finish, cycleDuration);
        }
        schedule();
      }, cycleDelay);
    };

    const restart = () => {
      cancel();
      schedule();
    };

    const suspend = () => {
      paused = true;
      cancel();
    };

    const resume = () => {
      paused = false;
      restart();
    };

    overlay.addEventListener('animationend', (event) => {
      if (event.target === overlay || event.target === rig) finish();
    });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) suspend();
      else resume();
    });
    window.addEventListener('blur', suspend);
    window.addEventListener('focus', resume);
    window.addEventListener('pagehide', suspend);
    window.addEventListener('pageshow', resume);
    reducedMotion.addEventListener('change', restart);
    forcedColors.addEventListener('change', restart);
    restart();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
